module.exports = __webpack_public_path__ + "img/icon_zhuanyenandian.dbc2c2b0.svg";